"use client";
import { useState, useEffect, useRef } from "react";
import { CN_PRODUCT } from "@/components/product/const";
import { PropsWithChildren } from "react";

import ArrowIcon from "@/images/icon/arrow-default.svg";
import { queryPlatMind } from "@/apis/service";
import { sendClickTrack, EXPOSURE_RECORD } from "@/tracks/25217";
import { dataExpTagConfig } from "@/components/product/const";
// styles

import { AssuranceWrapper } from "@/styles/product";
import { ErrorBoundary } from "react-error-boundary";
import AgeVerification from "./verifyAge";
import RichComponent from "@/components/product/richComponent";

const Accordion = ({ noBottomBorder, children }: { noBottomBorder?: boolean } & PropsWithChildren) => {
  return <div className={`${CN_PRODUCT("sku-assurance")} ${noBottomBorder ? "noBottomBorder" : ""}`}>{children}</div>;
};
// styles

function Assurance({ floors, skuId }: any) {
  const [isClient, setIsClient] = useState(false);
  const productShipPromiseFloor = floors.productShipPromiseFloor?.data;
  const guarantee = productShipPromiseFloor?.["C-M#viewAddressItem&guarantee"]?.items;

  
  // productComplianceFloor 烟酒年龄限制

  const productComplianceFloor = floors.productComplianceFloor?.data;

  const recycling = productShipPromiseFloor?.recycle;
  useEffect(() => {
    setIsClient(true);
  }, []);
  const [collapseActive, setCollapseActive] = useState<Record<string, boolean>>({
    weAccept: true,
  });
  const [weAccept, setWeAccept] = useState<any>();

  const onGuaranteeClick = (index: number | string, text?: string) => {
    if (text) {
      sendClickTrack.Productdetail_BasicServiceFloor_Click({
        mainskuid: skuId,
        displayText: text,
      });
    }
    setCollapseActive({ ...collapseActive, [index]: !collapseActive[index] });
  };
  const initQueryPlatMind = async () => {
    const res = await queryPlatMind();
    setWeAccept(res);
  };

  useEffect(() => {
    initQueryPlatMind();
  }, []);

  return (
    <AssuranceWrapper>
      {guarantee?.map((item: any, index: number) => {
        const styles = !collapseActive[index] ? { height: 0 } : {};
        const { logoUrl } = item || {};
        if (!item?.title) {
          return null;
        }
        return (
          <Accordion key={index}>
            {/* {JSON.stringify(item)} */}
            <div
              className={`accordion-summary ${!collapseActive[index] ? "expanded" : ""}`}
              onClick={() => onGuaranteeClick(index, item.title)}
              exptag={"exp|" + EXPOSURE_RECORD.Productdetail_BasicServiceFloor_Expo}
              data-exptag-config={dataExpTagConfig}
              data-exptag-json-param={JSON.stringify({ mainskuid: skuId, displayText: item.title })}
            >
              {/* {logoUrl && <CDNImage src={logoUrl} width={20} height={20} alt="icon" />} */}
              <p>{item.title}</p>
              <div className="arrow-wrapper">
                <ArrowIcon />
              </div>
            </div>
            <div className="accordion-detail" style={styles}>
              {isClient && <p className="content common-editor" dangerouslySetInnerHTML={{ __html: item.content }}></p>}
            </div>
          </Accordion>
        );
      })}

      {recycling && (
        <Accordion key="recycling">
          <div
            className={`accordion-summary ${!collapseActive["recycling"] ? "expanded" : ""}`}
            onClick={() => onGuaranteeClick("recycling", recycling.title)}
            exptag={"exp|" + EXPOSURE_RECORD.Productdetail_BasicServiceFloor_Expo}
            data-exptag-config={dataExpTagConfig}
            data-exptag-json-param={JSON.stringify({ mainskuid: skuId, displayText: recycling.title })}
          >
            {/* {logoUrl && <CDNImage src={logoUrl} width={20} height={20} alt="icon" />} */}
            <p>{recycling.title}</p>
            <div className="arrow-wrapper">
              <ArrowIcon />
            </div>
          </div>
          <div className="accordion-detail" style={!collapseActive["recycling"] ? { height: 0 } : {}}>
            {isClient && <p className="content common-editor" dangerouslySetInnerHTML={{ __html: recycling?.detailText }}></p>}
          </div>
        </Accordion>
      )}

      <AgeVerification data={productComplianceFloor} />
      <ErrorBoundary fallback={null}>
        {weAccept && (
          <>
            <div className={`accordion-summary ${!collapseActive["weAccept"] ? "expanded" : ""}`} onClick={() => onGuaranteeClick("weAccept")}>
              {/* {weAccept?.icon && <CDNImage src={weAccept?.icon} width={20} height={20} alt="icon" />} */}
              <p>{weAccept?.serviceTitle}</p>
              <div className="arrow-wrapper">
                <ArrowIcon />
              </div>
            </div>
            <div className="accordion-detail" style={!collapseActive["weAccept"] ? { height: 0 } : {}}>
              <RichComponent className="content" data={weAccept?.serviceContent} />
              {/* <p className="content" dangerouslySetInnerHTML={{ __html: weAccept?.serviceContent }}></p> */}
            </div>
          </>
        )}
      </ErrorBoundary>
    </AssuranceWrapper>
  );
}
export default Assurance; 
